export const DEFAULT_ERROR_MSG =
    'Vi är ledsna, det var ett fel, försök igen senare';
